import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../Services/axiosCommon";
import useDebounce from "./useDebounce";

const EMPTY_ARRAY = [];

const separateParams = (params) => {
  if (!params || typeof params !== "object") {
    return { instantParams: {}, searchParams: {} };
  }

  const instantParams = {};
  const searchParams = {};

  // Parameters that represent free-text search inputs to be debounced
  const textSearchKeys = ["search", "searchQuery", "description"];

  Object.entries(params).forEach(([key, value]) => {
    if (textSearchKeys.includes(key)) {
      searchParams[key] = value;
    } else {
      instantParams[key] = value;
    }
  });

  return { instantParams, searchParams };
};

const UseGetDataSearch = (url, params = null) => {
  const { instantParams, searchParams } = separateParams(params);
  const instantString = JSON.stringify(instantParams);
  const searchParamsString = JSON.stringify(searchParams);
  const debouncedSearchParamsString = useDebounce(searchParamsString, 500);

  const { data: responseData, isLoading, isFetching, refetch } = useQuery({
    queryKey: [url, instantString, debouncedSearchParamsString],
    queryFn: async () => {
      const parsedInstant = JSON.parse(instantString);
      const parsedSearch = JSON.parse(debouncedSearchParamsString);
      const combinedParams = { ...parsedSearch, ...parsedInstant };
      const res = await axiosInstance.get(url, { params: combinedParams });
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    placeholderData: (previousData) => previousData,
  });

  const isPaginated =
    params?.page !== "" &&
    (params?.pageCount !== "" || params?.per_page !== "");

  const data = responseData
    ? (isPaginated && responseData.data?.data ? responseData.data.data : (responseData.data || EMPTY_ARRAY))
    : EMPTY_ARRAY;

  const totalCount = responseData
    ? (isPaginated && responseData.data?.data ? responseData.data.total : 0)
    : 0;

  const credit = responseData?.credit || 0;
  const advance = responseData?.advance || 0;
  const total = responseData?.data?.total || 0;

  const getData = () => {
    refetch();
  };

  return {
    data,
    totalCount,
    credit,
    advance,
    getData,
    dataLoading: isLoading || isFetching,
    total,
  };
};

export default UseGetDataSearch;
